import "bootstrap/dist/css/bootstrap.min.css";
import "../src/global.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, { Suspense } from "react";
import Home from "./pages/home/Home";
import BouwInfra from "./pages/bouwInfra/Bouw-Infra";
import Scheepvaart from "./pages/scheepvaart/Scheepvaart";
import Industrie from "./pages/industrie/Industrie";
import InkoopLogistiek from "./pages/inkoopLogistiek/InkoopLogistiek";
import DePloegopdeRoot from "./pages/DePloegopdeRoot/DePloegopdeRoot";
import Partners from "./pages/partners/Partners";
import WiezijnWij from "./pages/wiezijnwij/WiezijnWij";
import CertificeringenenBrancheverenigingen from "./pages/CertificeringenenBrancheverenigingen/CertificeringenenBrancheverenigingen";
// import MaatschappelijkVerantwoordOndernemenSponsoring from "./pages/maatschappelijk Verantwoord Ondernemen & Sponsoring/MaatschappelijkVerantwoordOndernemen&Sponsoring";
import Inschrijven from "./pages/inschrijven/Inschrijven";
import SocialMediaLink from "./pages/socialmedialink/SocialMediaLink";
import Chatbot from "./components/Chatbot";
import Businessclub from "./pages/businessclub/BusinessClub1";
import NotFound from "./components/NotFound";
import CrossborderRecruitment from "./pages/CrossborderRecruitment/CrossborderRecruitment";
import SalesFinance from "./pages/salesfinance/SalesFinance";
import InkoopenLogistiek from "./pages/inkoopenlogistiek/InkoopenLogistiek";
import HROrganisatieadvies from "./pages/hrenorganisatieadvies/HROrganisatieadvies";
import OverigeDiensten from "./pages/overigediensten/OverigeDiensten";
import Mvo from "./pages/mvo/Mvo";
import Sponsoring from "./pages/sponsoring/Sponsoring";
import Nieuws from "./pages/nieuws/Nieuws";
import { loadBlogs } from "./utils/loadBlogs.client";
import Blog from "./components/BlogComponent/Blog";

function App() {
  const blogs = loadBlogs();
  return (
    <BrowserRouter>
      <Suspense>
        <Chatbot />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Bouw-Infra" element={<BouwInfra />} />
          <Route path="/Scheepvaart" element={<Scheepvaart />} />
          <Route path="/Industrie" element={<Industrie />} />
          <Route path="/InkoopLogistiek" element={<InkoopLogistiek />} />
          <Route path="/Ploeg-Op-De-Root" element={<DePloegopdeRoot />} />
          <Route path="/Partners" element={<Partners />} />
          <Route path="/wie-zijn-wij" element={<WiezijnWij />} />
          <Route
            path="/VCU/VCA/NEN-Certificering"
            element={<CertificeringenenBrancheverenigingen />}
          />
          <Route
            path="/diensten/inkoop-en-logistiek"
            element={<InkoopenLogistiek />}
          />
          <Route
            path="/diensten/crossborder-recruitment-en-detachering"
            element={<CrossborderRecruitment />}
          />
          <Route path="/diensten/sales-en-finance" element={<SalesFinance />} />
          <Route
            path="/diensten/hr-en-organisatieadvies"
            element={<HROrganisatieadvies />}
          />
          <Route
            path="/diensten/overige-diensten"
            element={<OverigeDiensten />}
          />

          <Route
            path="/inkoop-en-logistiek"
            element={<Navigate to="/diensten/inkoop-en-logistiek" replace />}
          />
          <Route
            path="/crossborder-recruitment-en-detachering"
            element={
              <Navigate
                to="/diensten/crossborder-recruitment-en-detachering"
                replace
              />
            }
          />
          <Route
            path="/sales-en-finance"
            element={<Navigate to="/diensten/sales-en-finance" replace />}
          />
          <Route
            path="/hr-en-organisatieadvies"
            element={
              <Navigate to="/diensten/hr-en-organisatieadvies" replace />
            }
          />
          <Route
            path="/overige-diensten"
            element={<Navigate to="/diensten/overige-diensten" replace />}
          />
          <Route
            path="/maatschappelijk-verantwoord-ondernemen"
            element={<Mvo />}
          />
          <Route path="/nieuws" element={<Nieuws />} />
          <Route path="/sponsoring" element={<Sponsoring />} />
          <Route path="/inschrijven" element={<Inschrijven />} />
          <Route path="/Social-Media-Link" element={<SocialMediaLink />} />
          <Route path="/Business-Club" element={<Businessclub />} />
          {blogs.map(({ slug, sections, title }) => (
            <Route
              key={slug}
              path={`/blogs/${slug}`}
              element={<Blog title={title || slug} sections={sections} />}
            />
          ))}
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
